import {Component, OnDestroy, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {ContatosService} from '../../services/contatos.service';
import {NotificationService} from '@progress/kendo-angular-notification';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {FiltroAvancadoComponent} from "../../componentes/filtro-avancado/filtro-avancado.component";
import {UsuarioService} from "../../services/usuario.service";
import {PlanosService} from "../../services/planos.service";
import {FiltroTelaUI} from "../../../../projects/loja/src/objeto/FiltroTelaUI";
import {ConstantsService} from "../ConstantsService";
import {linkWhatsApp, SEGMENTOS_CRM, SegmentoCrm} from "../crm/crm-segmentos";
import {RegrasCrmTela} from "../crm/regras-crm/regras-crm.component";
declare var _;

/** Kanban de contatos com os sete segmentos do CRM; colunas vazias ficam fechadas até um clique. */
@Component({
  selector: 'app-kanban-contatos',
  templateUrl: './kanban-contatos.component.html',
  styleUrls: ['./kanban-contatos.component.scss']
})
export class KanbanContatosComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('filtroComponent') filtroComponent: FiltroAvancadoComponent;

  public Object = Object;
  public filtroAberto = false;
  private empresaAtual: any;
  private assinaturaEmpresa: Subscription;

  public readonly colunas: SegmentoCrm[] = SEGMENTOS_CRM;
  public termoBusca = '';

  public paginacaoPorStatus: { [key: string]: number } = {};
  public carregandoPorStatus: { [key: string]: boolean } = {};
  private fimDaPaginaPorStatus: { [key: string]: boolean } = {};
  public totalPorStatus: { [key: string]: number } = {};
  public contatosPorStatus: { [key: string]: any[] } = {};
  public tamanhoPagina = 20;
  public carregando = false;
  /** Cada recarga ganha um número; resposta de uma recarga anterior é descartada. */
  private requisicao = 0;

  public regras: RegrasCrmTela = null;
  public regrasEditadasEm: string = null;
  public defaultCalculadoEm: string = null;
  public regrasAbertas = false;
  /** Colunas vazias que a pessoa abriu (vazias ficam fechadas numa faixa estreita). */
  public colunasAbertas: { [codigo: string]: boolean } = {};

  public filtro: any = { id: -1, dados: {}, nome: 'Todos os contatos', exibir: false };
  public filtros: any = [ this.filtro ];
  public planos = [];
  public plano: any = {};
  public modalSalvarFiltro = false;
  public erroSalvarFiltro: string;

  constructor(
    private contatosService: ContatosService,
    private notificationService: NotificationService,
    private router: Router,
    private usuarioService: UsuarioService,
    private planosService: PlanosService,
    private constantsService: ConstantsService
  ) {
    this.zereColunas();
  }

  ngOnInit() {
    this.assinaturaEmpresa = this.constantsService.empresa$.subscribe(empresa => {
      if (empresa && (!this.empresaAtual || this.empresaAtual.id !== empresa.id)) {
        this.empresaAtual = empresa;
        this.carregarDados();
      }
    });
  }

  ngAfterViewInit() {
    if (this.filtroComponent) {
      this.filtroComponent.setPlanos(this.planos);
    }
  }

  ngOnDestroy() {
    if (this.assinaturaEmpresa) this.assinaturaEmpresa.unsubscribe();
  }

  private zereColunas() {
    this.colunas.forEach(coluna => {
      this.paginacaoPorStatus[coluna.codigo] = 0;
      this.carregandoPorStatus[coluna.codigo] = false;
      this.fimDaPaginaPorStatus[coluna.codigo] = false;
      this.totalPorStatus[coluna.codigo] = 0;
      this.contatosPorStatus[coluna.codigo] = [];
    });
  }

  async carregarDados() {
    this.carregando = true;
    try {
      this.carregueResumoCrm();
      this.planos = await this.planosService.listePlanos();
      this.plano = this.planos.length === 1 ? this.planos[0] : {};
      if (this.filtroComponent) this.filtroComponent.setPlanos(this.planos);
      await this.carregarContatos();
      const filtros = await this.usuarioService.listeFiltros();
      this.filtros = _.union(this.filtros, filtros);
    } catch (erro) {
      console.error('Erro ao carregar dados:', erro);
      this.avise('Erro ao carregar os clientes', 'error');
    } finally {
      this.carregando = false;
    }
  }

  carregueResumoCrm() {
    return this.contatosService.obtenhaResumoCrm().then((dados: any) => {
      this.regras = dados.regras;
      this.regrasEditadasEm = dados.regrasEditadasEm;
      this.defaultCalculadoEm = dados.defaultCalculadoEm;
    }).catch(() => {});
  }

  getParamsFiltro() {
    if (this.termoBusca && this.termoBusca.trim() !== '') {
      this.filtro.dados.q = this.termoBusca;
    } else {
      delete this.filtro.dados.q;
      delete this.filtro.q;
    }
    return FiltroTelaUI.getParamsRequest(this.filtro.dados);
  }

  private paramsDaColuna(coluna: SegmentoCrm) {
    return {idEmpresa: this.empresaAtual.id, ...this.getParamsFiltro(), st: coluna.codigo, acionavel: 1, ordemCrm: coluna.ordem};
  }

  async carregarContatos() {
    const requisicao = ++this.requisicao;
    try {
      await this.carregarResumo(requisicao);
      await Promise.all(this.colunas.map(coluna =>
        this.contatosService.listeContatos(0, this.tamanhoPagina, this.paramsDaColuna(coluna)).then(contatos => {
          if (requisicao !== this.requisicao) return;
          this.contatosPorStatus[coluna.codigo] = contatos;
          this.paginacaoPorStatus[coluna.codigo] = 0;
          this.fimDaPaginaPorStatus[coluna.codigo] = contatos.length < this.tamanhoPagina;
        })
      ));
    } catch (erro) {
      console.error('Erro ao carregar contatos:', erro);
      this.avise('Erro ao carregar os clientes', 'error');
    }
  }

  async carregarResumo(requisicao: number = this.requisicao) {
    const resumo = await this.contatosService.listeResumo({...this.getParamsFiltro(), acionavel: 1});
    if (requisicao !== this.requisicao) return;
    this.colunas.forEach(coluna => this.totalPorStatus[coluna.codigo] = 0);
    (resumo || []).forEach(item => {
      const codigo = String(item.status || '').toUpperCase();
      this.totalPorStatus[codigo] = (this.totalPorStatus[codigo] || 0) + (item.qtde || 0);
    });
  }

  onScrollColuna(codigo: string) {
    if (this.fimDaPaginaPorStatus[codigo] || this.carregandoPorStatus[codigo]) return;
    const coluna = this.colunas.find(c => c.codigo === codigo);
    const pagina = this.paginacaoPorStatus[codigo] + 1;

    const requisicao = this.requisicao;
    this.carregandoPorStatus[codigo] = true;
    this.contatosService.listeContatos(pagina * this.tamanhoPagina, this.tamanhoPagina, this.paramsDaColuna(coluna)).then(contatos => {
      if (requisicao !== this.requisicao) return;
      this.paginacaoPorStatus[codigo] = pagina;
      this.contatosPorStatus[codigo] = [...(this.contatosPorStatus[codigo] || []), ...contatos];
      this.fimDaPaginaPorStatus[codigo] = contatos.length < this.tamanhoPagina;
    }).catch(erro => {
      console.error(`Erro ao carregar mais contatos de ${codigo}:`, erro);
    }).finally(() => this.carregandoPorStatus[codigo] = false);
  }

  recarregue() {
    this.zereColunas();
    this.carregando = true;
    this.carregarContatos().finally(() => this.carregando = false);
  }

  onBuscaChange(termo: string) {
    this.termoBusca = termo;
    if (!termo || termo.trim() === '') delete this.filtro.q; else this.filtro.q = termo;
    this.recarregue();
  }

  exibaFiltroAvancado() {
    this.filtroAberto = true;
    this.filtro.exibir = true;
    setTimeout(() => {
      if (this.filtroComponent) {
        this.filtroComponent.setPlanos(this.planos);
        this.filtroComponent.setFiltroAvancado(this.filtro.dados);
      }
    });
  }

  fecharFiltroAvancado(): void {
    this.filtroAberto = false;
    this.filtro.exibir = false;
    if (this.filtroComponent) this.filtroComponent.exibir = false;
  }

  onFiltrarAvancado(filtro: any) {
    this.filtro.dados = filtro;
    this.filtro.salvar = true;
    this.filtro.exibir = false;
    this.recarregue();
  }

  getDescricaoFiltro(filtro: any) {
    if (typeof filtro === 'string') {
      if (!this.filtro.q) return '';
      return 'Buscando por: "' + this.filtro.q + '"';
    }
    const label = FiltroTelaUI.getLabel(filtro);
    return (label === true || label === false) ? filtro.nome : filtro.nome + ': ' + label;
  }

  abraModalSalvarFiltro() {
    if (!this.filtro.id) this.filtro.nome = '';
    this.modalSalvarFiltro = true;
  }

  fecheModalFiltro() {
    this.modalSalvarFiltro = false;
  }

  salveFiltro() {
    delete this.erroSalvarFiltro;
    if (!this.filtro.nome) {
      this.erroSalvarFiltro = 'informa um nome para o filtro';
      return;
    }
    this.usuarioService.salveFiltro(this.filtro).then(resp => {
      this.filtro.id = resp.id;
      this.fecheModalFiltro();
    }).catch((erro) => this.erroSalvarFiltro = erro);
  }

  limpeFiltros() {
    this.filtro.dados = {};
    delete this.filtro.id;
    this.termoBusca = '';
    this.recarregue();
  }

  removerFiltro(key: any) {
    delete this.filtro.dados[key.toString()];
    delete this.filtro[key];
    if (key === 'q') this.termoBusca = '';
    this.recarregue();
  }

  getContatosPorStatus(codigo: string): any[] {
    return this.contatosPorStatus[codigo] || [];
  }

  getExibindoTotal(codigo: string) {
    return `${this.getContatosPorStatus(codigo).length}/${this.totalPorStatus[codigo] || 0}`;
  }

  alterneColuna(codigo: string) {
    if (this.getContatosPorStatus(codigo).length === 0) this.colunasAbertas[codigo] = !this.colunasAbertas[codigo];
  }

  abrirWhatsApp(contato: any) {
    window.open(linkWhatsApp(contato), '_blank');
  }

  /** CSV do filtro atual; com segmento, só aquela coluna. */
  exporte(codigo: string = null) {
    const params: any = {...this.getParamsFiltro(), acionavel: 1};
    if (codigo) {
      params.st = codigo;
      params.ordemCrm = this.colunas.find(c => c.codigo === codigo).ordem;
    }
    this.baixe(this.contatosService.urlExportacaoCrm(params));
  }

  private baixe(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  salvouRegras(regras: RegrasCrmTela & {recalculando: boolean}) {
    this.regras = regras;
    this.regrasEditadasEm = new Date().toISOString();
    this.regrasAbertas = false;
    this.avise(regras.recalculando
      ? 'Regras salvas. Os clientes estão sendo reclassificados e as colunas atualizam em alguns minutos.'
      : 'Regras salvas. Já havia um recálculo em andamento; quando ele terminar, use "Recalcular agora" para aplicar as novas regras.', 'success');
  }

  verContato(contato: any) {
    let link = '/admin/contatos';
    if (contato.telefone) {
      link = `${link}/${contato.codigoPais}${contato.telefone}`;
    } else {
      const documento = contato.cpf || contato.cnpj;
      if (documento) link = `${link}/documento/${documento}`;
    }
    this.router.navigate([link], { state: { contato } });
  }

  private avise(texto: string, estilo: 'success' | 'error') {
    this.notificationService.show({
      content: texto,
      hideAfter: 4000,
      position: { horizontal: 'right', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      type: { style: estilo, icon: true }
    });
  }
}
